import { BaseLayoutElement } from "./_base-element";

export class LayoutElementUnknown extends BaseLayoutElement {
    _unknown: true = true;
}
